import { constantsTypes } from '../reduxConstants';

const initialState = {
  showVoucherListing: 0,
};

export const singlepagevoucherlistingReducer = (state = initialState, action) => {
  switch (action.type) {
    case constantsTypes.VIEW_MODE_VOUCHERLISTING:
      return {
        ...state,  
        showVoucherListing: action.value,  
      };
    default:
      return state;
  }
};
